<template>
  <div class="notifications">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <h1>通知系统</h1>
          <div class="notification-management">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-select
                  v-model="filterType"
                  placeholder="筛选通知类型"
                  clearable
                  @clear="handleFilterClear"
                   empty-text="暂无未读通知"
                >
                  <el-option label="终端电量低" value="lowBattery" />
                  <el-option label="基站掉线" value="baseStationOffline" />
                  <el-option label="其他" value="other" />
                </el-select>
              </el-col>
            </el-row>

            <el-table :data="filteredNotifications" style="width: 100%; margin-top: 20px;">
              <el-table-column prop="type" label="通知类型">
                <template #default="scope">
                  <el-tag :type="getTagType(scope.row.type)">
                    {{ getTypeLabel(scope.row.type) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="content" label="通知内容" />
              <el-table-column prop="time" label="通知时间" sortable />
              <el-table-column label="操作">
                <template #default="scope">
                  <el-button type="text" @click="handleMarkAsRead(scope.row)">标记为已读</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'NotificationSystem',
  data() {
    return {
      notifications: [
        { id: '001', type: 'lowBattery', content: '终端 ID 001 电量低于 20%', time: '2025-03-13 10:00:00' },
        { id: '002', type: 'baseStationOffline', content: '基站 ID 002 已掉线', time: '2025-03-13 10:05:00' },
        { id: '003', type: 'other', content: '系统维护通知', time: '2025-03-13 10:10:00' },
        { id: '004', type: 'lowBattery', content: '终端 ID 004 电量低于 10%', time: '2025-03-13 10:15:00' },
        { id: '005', type: 'baseStationOffline', content: '基站 ID 005 已掉线', time: '2025-03-13 10:20:00' }
      ],
      readNotifications: [], // 存储已读通知的ID
      filterType: ''
    };
  },
  computed: {
    filteredNotifications() {
      return this.notifications.filter(notification => {
        return (
          !this.filterType || notification.type === this.filterType
        ) && !this.readNotifications.includes(notification.id); // 过滤掉已读的通知
      });
    }
  },
  methods: {
    getTagType(type) {
      switch (type) {
        case 'lowBattery':
          return 'warning';
        case 'baseStationOffline':
          return 'danger';
        default:
          return 'info';
      }
    },
    getTypeLabel(type) {
      switch (type) {
        case 'lowBattery':
          return '终端电量低';
        case 'baseStationOffline':
          return '基站掉线';
        default:
          return '其他';
      }
    },
    handleFilterClear() {
      this.filterType = '';
    },
    handleMarkAsRead(row) {
      this.readNotifications.push(row.id); // 将通知ID添加到已读列表中
      this.$message.success(`已标记通知 ${row.id} 为已读`);
    }
  }
};
</script>

<style scoped>
.notifications {
  padding: 20px;
}

.notification-management {
  margin-top: 20px;
}
</style>
